import { forwardRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const withRouterAndRef = WrappedComponent => {
	const ComponentWithRouter = forwardRef((props, ref) => {
		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();

		const history = {
			push: (pathOrObj) => {
				if (typeof pathOrObj === 'string') navigate(pathOrObj);
				else navigate(pathOrObj.pathname, { state: pathOrObj.state });
			},
			replace: (pathOrObj) => {
				if (typeof pathOrObj === 'string') navigate(pathOrObj, { replace: true });
				else navigate(pathOrObj.pathname, { state: pathOrObj.state, replace: true });
			},
			goBack: () => navigate(-1),
			listen: () => () => {},
			location,
		};

		return <WrappedComponent {...props} ref={ref} location={location} navigate={navigate} params={params} history={history} match={{ params }} />;
	});

	const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	ComponentWithRouter.displayName = `withRouterAndRef(${displayName})`;

	return ComponentWithRouter;
};

export default withRouterAndRef;
